import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, Card, theme } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

import SimpleGeneral from './simpleGeneral';
import SimpleDetails from './simpleDetails';
import SimpleUnits from './simpleUnits';
import SimplePrice from './simplePrices';
import Compounds from './compounds';
import { TbBoxModel } from 'react-icons/tb';






const SimpleForm = (props) => {


    const { showModal, toggleModal, idRow, refreshTable, refAddedData, type } = props;

    const { api, userData, settingData, accountData, wareHouseData, selectedCompany,
        productData, refData, defaultCurrency, salableData, currencyData, formLanguages } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);
    const companyId = selectedCompany.id;

    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const [simpleProduct, setSimpleProduct] = useState(true);
    const [productUnits, setProductUnits] = useState([]);
    const [productPrices, setProductPrices] = useState([]);
    const [productCompounds, setProductCompounds] = useState([]);

    const today = new Date().toISOString().split('T')[0];






    // idRow Change
    useEffect(() => {
        if (!isLoading) {
            const raiseBy = idRow?.cost != 0 ? ((idRow?.price - idRow?.cost) / idRow?.cost) * 100 : 0;

            let isActive = true;
            let isStock = true;
            if (idRow) {
                isActive = idRow?.isActive ? true : false;
                isStock = idRow?.isStock ? true : false;
            }

            if (type == 'compound') {
                isStock = false;
            }

            setSimpleProduct({
                companyId: companyId,
                type: type,
                type: idRow?.type || type,

                isActive: isActive,
                isStock: isStock,

                barcode: idRow?.barcode || null,
                name: idRow?.name || null,
                categoryId: idRow?.categoryId || null,
                vatGroupId: idRow?.vatGroupId || null,

                currencyId: idRow?.currencyId || defaultCurrency.id,
                cost: idRow?.cost || 0,
                raiseBy: raiseBy || 0,
                price: idRow?.price || 0,
                unit: idRow?.unit || 'Pcs',
                brandId: idRow?.brandId || null,
            })

            setProductPrices(idRow?.prices || settingData.defaultMultiPrices)
            setProductUnits(idRow?.units || [])

            if (idRow?.type == 'compound') {
                setCompoundsForEdit();
            }
        }
    }, [isLoading, idRow]);


    const setCompoundsForEdit = () => {
        const updatedProductCompounds = [...idRow?.productCompounds]
        for (const compound of updatedProductCompounds) {
            const product = salableData.find(item => item.id === compound.productId);
            compound.cost = product.cost;
            compound.totalCost = product.cost * compound.quantity;
        }
        const productCost = updatedProductCompounds.reduce((sum, compound) => sum + (Number(compound.totalCost) || 0), 0);
        setSimpleProduct(prev => ({ ...prev, cost: productCost }));
        setProductCompounds(updatedProductCompounds || [])
    }

    useEffect(() => {
        if (showModal) {
            fetchData();
        } else {
            setIsLoading(true)
        }
    }, [showModal]);



    const fetchData = async () => {
        try {

            let dataArray;

            if (refAddedData) {
                dataArray = ['account', 'category', 'season', 'brand', 'vatGroup'];
            } else {
                if (type == 'compound') {
                    dataArray = ['account', 'category', 'season', 'brand', 'vatGroup', 'currency', 'salable']
                } else {
                    dataArray = ['account', 'category', 'season', 'brand', 'vatGroup', 'currency']
                }
            }

            await refData(dataArray, companyId);
            setIsLoading(false);
        } catch (error) {
            console.error('Error refreshing data Contact Support');
        }
    };




    const closeModal = () => {
        toggleModal();
        if (refreshTable) { refreshTable(); }
        resetForm();
        setValidated(false);
    }

    const resetForm = () => {
        setSimpleProduct({
            companyId: companyId,
            type: type,

            isActive: true,
            isStock: true,

            currencyId: defaultCurrency.id,
            cost: 0,
            raiseBy: 0,
            price: 0,

            unit: idRow?.unit || 'Pcs',
        })

        setProductCompounds([]);
        setProductPrices([]);
        setProductUnits([]);
    }



    const refAddedProduct = async () => {
        try {
            const dataArray = ['salable']
            await refData(dataArray, companyId);
        } catch (error) {
            console.error('Error refreshing data Contact Support');
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoadingEffect(true);
        const form = document.getElementById('productForm');

        if (form.checkValidity() === false) {
        }

        const data = {
            simpleProduct,
            productPrices,
            productUnits,
            companyId,
            productId: idRow?.id,
            productCompounds,
        }

        const operation = idRow ? 'editSimple' : 'addSimple';

        try {
            let res = await api.post(`product/${operation}`, data);

            if (res.data.status) {
                toast.success(res.data.message);
                form.reset();
                if (refAddedData) { refAddedProduct() };
                if (idRow) { closeModal() }
                else { resetForm() }
            } else {
                toast.error(res.data.message);   
            }
        } catch (error) {
            toast.error("Failed Contact Support");
        } finally {
            setLoadingEffect(false);
            setValidated(false);
        }
    }



    return (
        <>
            <Modal show={showModal} size={'xl'} onHide={closeModal} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} backdrop="static">

                <Modal.Header style={{ background: "#23576a" }} closeButton>
                    <Modal.Title style={{ color: "white" }}>{type?.charAt(0)?.toUpperCase() + type?.slice(1)} {formLanguages.Products}</Modal.Title>
                </Modal.Header>

                {isLoading &&
                    <div style={{ height: '20vh' }}>
                        <Loader />
                    </div>
                }

                {!isLoading &&
                    <Form validated={validated} id={'productForm'} onSubmit={handleSubmit}>
                        <Modal.Body className="custom-scrollbar" style={{ backgroundColor: '#f0f2f5', maxHeight: '75vh', overflowY: 'auto' }}>

                            <Row className="mb-1">
                                <Col className="mb-4">
                                    <Card title="General" bordered={false}>
                                        <SimpleGeneral
                                            simpleProduct={simpleProduct}
                                            setSimpleProduct={setSimpleProduct}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                            {type == 'compound' &&
                                <Row className="mb-3">

                                    <Col>
                                        <Card title="Compounds" bordered={false}>
                                            <Compounds
                                                simpleProduct={simpleProduct}
                                                setSimpleProduct={setSimpleProduct}
                                                productCompounds={productCompounds}
                                                setProductCompounds={setProductCompounds}
                                            />
                                        </Card>
                                    </Col>
                                </Row>
                            }

                            <Row className="mb-3">

                                <Col md={5}>
                                    <Card title={formLanguages.Prices} bordered={false}>
                                        <SimplePrice
                                            simpleProduct={simpleProduct}
                                            setSimpleProduct={setSimpleProduct}
                                            productPrices={productPrices}
                                            setProductPrices={setProductPrices}
                                        />
                                    </Card>
                                </Col>

                                <Col md={7}>
                                    <Card title={formLanguages.Units} bordered={false}>
                                        <SimpleUnits
                                            simpleProduct={simpleProduct}
                                            setSimpleProduct={setSimpleProduct}
                                            productUnits={productUnits}
                                            setProductUnits={setProductUnits}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>

                                    <Card title={formLanguages.Details} bordered={false}>
                                        <SimpleDetails
                                            simpleProduct={simpleProduct}
                                            setSimpleProduct={setSimpleProduct}
                                        />
                                    </Card>
                                </Col>
                            </Row>


                        </Modal.Body>

                        <Modal.Footer>

                            <Button type="primary" loading={loadingEffect} htmlType="submit"
                                onClick={() => setValidated(true)}
                                style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>{formLanguages.Save}</Button>
                        </Modal.Footer>
                    </Form>
                }


            </Modal >
        </>
    )
}


export default SimpleForm;